// extracted by mini-css-extract-plugin
export var img_container = "index-module--img_container--5zgnx";
export var header = "index-module--header--qgXpw";